var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.982 14.85L13.157 11.25L15.932 8.85L12.282 8.525L10.832 5.125V12.925L13.982 14.85ZM4.65703 19L6.28203 11.975L0.832031 7.25L8.03203 6.625L10.832 0L13.632 6.625L20.832 7.25L15.382 11.975L17.007 19L10.832 15.275L4.65703 19Z",
    fill: "#F29F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star_half.f57baa042c02eef2fd9c9cd3e80f146a.svg";
export { ForwardRef as ReactComponent };